"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownParentContext = void 0;
var React = require("react");
var react_popper_1 = require("react-popper");
var Keyboard_1 = require("../../_Core/Keyboard");
var Theme_1 = require("../../Theme");
var DropdownParent_styles_1 = require("./DropdownParent.styles");
exports.DropdownParentContext = React.createContext({});
exports.default = (function (_a) {
    var DropdownToggleContent = _a.DropdownToggleContent, DropdownMenuContent = _a.DropdownMenuContent, DropdownWidth = _a.DropdownWidth, HasErrors = _a.HasErrors, IsDisabled = _a.IsDisabled, OnBlur = _a.OnBlur;
    var _b = React.useState(false), IsDropdownOpen = _b[0], SetIsDropdownOpen = _b[1];
    React.useEffect(function () {
        if (IsDropdownOpen) {
            document.addEventListener("click", handleOnPageClick, false);
        }
        return function () {
            document.removeEventListener("click", handleOnPageClick, false);
        };
    }, [IsDropdownOpen]);
    var controlRef = React.createRef();
    var toggleRef = React.useRef();
    var menuRef = React.useRef();
    var handleOnPageClick = function () {
        if (IsDropdownOpen) {
            SetIsDropdownOpen(false);
        }
        if (OnBlur) {
            OnBlur();
        }
    };
    /**
     * Keyboard functions
     */
    var stopPropagationPreventDefault = function (e) {
        e.stopPropagation();
        e.preventDefault();
    };
    var handleKeyDown = function (e) {
        if (IsDisabled) {
            return;
        }
        if (!IsDropdownOpen) {
            if (Keyboard_1.IsDownArrow(e)) {
                stopPropagationPreventDefault(e);
                SetIsDropdownOpen(true);
            }
        }
        if (Keyboard_1.IsEscape(e)) {
            stopPropagationPreventDefault(e);
            if (menuRef.current && menuRef.current.handleEscapeKeyPressed) {
                menuRef.current.handleEscapeKeyPressed();
            }
            if (toggleRef.current && toggleRef.current.handleEscapeKeyPressed) {
                toggleRef.current.handleEscapeKeyPressed();
            }
        }
    };
    var handleDropdownToggleKeyboardEvent = function (e) {
        if (IsDisabled) {
            return;
        }
        if (IsDropdownOpen) {
            if (Keyboard_1.IsDownArrow(e)) {
                stopPropagationPreventDefault(e);
                // Tell Content this happened
                if (menuRef.current) {
                    menuRef.current.handleDownKeyPressed();
                }
            }
        }
    };
    return (React.createElement(exports.DropdownParentContext.Provider, { value: {
            IsDropdownOpen: IsDropdownOpen,
            SetDropdownVisibility: SetIsDropdownOpen,
        } },
        React.createElement(DropdownParent_styles_1.Container, { onClick: function (e) { return e.nativeEvent.stopImmediatePropagation(); }, tabIndex: IsDisabled ? undefined : 0, ref: controlRef, onKeyDown: handleKeyDown },
            React.createElement(DropdownParent_styles_1.Wrapper, { Open: IsDropdownOpen },
                React.createElement(react_popper_1.Manager, null,
                    React.createElement(react_popper_1.Reference, null, function (_a) {
                        var popperRef = _a.ref;
                        return (React.createElement(DropdownParent_styles_1.ToggleWrapper, { ref: popperRef, Open: IsDropdownOpen, HasErrors: HasErrors, IsDisabled: IsDisabled },
                            React.createElement(DropdownToggleContent, { ref: toggleRef, OnKeyUp: handleDropdownToggleKeyboardEvent })));
                    }),
                    React.createElement(react_popper_1.Popper, { modifiers: [{ name: "flip", enabled: false }], placement: "bottom-start" }, function (_a) {
                        var popperRef = _a.ref, style = _a.style;
                        return IsDropdownOpen ? (React.createElement(DropdownParent_styles_1.MenuWrapper, { ref: popperRef, style: __assign(__assign({}, style), { zIndex: Theme_1.portalsZIndex }), Open: IsDropdownOpen, Width: DropdownWidth },
                            React.createElement(DropdownMenuContent, { ref: menuRef, DropdownMenuContent: DropdownMenuContent }))) : (React.createElement(React.Fragment, null));
                    }))))));
});
